import billingFrequencies from './billing-frequencies'
import bundleTypes from './bundle-types'
import inventoryTypes from './inventory-types'
import metricTypes from './metric-types'
import productCategories from './product-categories'
import productFamilies from './product-families'
import productStatuses from './product-statuses'
import productTypes from './product-types'
import products from './products'
import suppliers from './suppliers'

export default {
    billingFrequencies,
    bundleTypes,
    inventoryTypes,
    metricTypes,
    productCategories,
    productFamilies,
    productStatuses,
    productTypes,
    products,
    suppliers
}
